import LoginAPI from '@/api/login';
import isNil from 'lodash/isNil';
import RSA from 'node-rsa';

const user = {
  state: {
    /**
     * 로그인된 계정 정보
     * @type {[type]}
     */
    userInfo: null,
    /**
     * 계정 권한 (임시)
     * @type {Array}
     */
    roles: [],
    passwordPolicy: null,
  },
  mutations: {
    /**
     * 로그인된 계정 정보를 설정한다.
     * @author Ju
     * @param  {[type]} state    [description]
     * @param  {[type]} userInfo [description]
     */
    setUserInfo: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    /**
     * 로그인된 계정의 권한 정보를 설정한다.
     * @author Ju
     * @param  {[type]} state [description]
     * @param  {[type]} roles [description]
     */
    setRoles: (state, roles) => {
      state.roles = roles;
    },
    setPasswordPolicy: (state, passwordPolicy) => {
      state.passwordPolicy = passwordPolicy;
    },
  },
  actions: {
    /**
     * 로그인을 시도한다.
     * @author Ju
     * @param  {[type]} commit [description]
     * @param  {[type]} id     계정 아이디
     * @param  {[type]} pw     계정 패스워드
     * @return {[type]}        [description]
     */
    login({ commit }, { id, pw }) {
      return new Promise((resolve, reject) => {
        // 로그인 키 발급
        LoginAPI.getLoginKey()
          .then((response) => {
            if (!isNil(response.data)) {
              // RSA 암호화 처리
              const publicKey = response.data;
              const key = new RSA({ b: 1024 });
              key.setOptions({
                encryptSchemes: {
                  scheme: 'pkcs1-nopadding',
                },
              });
              key.importKey({
                n: Buffer.from(publicKey.pkm, 'hex'),
                e: parseInt(publicKey.pke, 16),
              }, 'components-public');
              const encId = key.encrypt(id, 'hex', 'utf8');
              const encPw = key.encrypt(pw, 'hex', 'utf8');
              // 로그인 시도
              LoginAPI.actionLogin(encId, encPw).then((res) => {
                resolve(res.data);
              });
            } else {
              reject(false);
            }
          })
          .catch(() => {
            reject(false);
          });
      });
    },
    logout: ({ commit }) =>
      new Promise((resolve, reject) => {
        LoginAPI.actionLogout()
          .then(() => {
            commit('setRoles', []);
            commit('setUserInfo', {});
            commit('setPasswordPolicy', {
              passwordChangeFlag: null,
              forcePasswordChangeFlag: null,
              passwordChangePeried: null,
            });
            resolve(true);
          })
          .catch(() => {
            reject(false);
          });
      }),
    /**
     * 로그인된 계정의 권한 정보를 설정한다.
     * @author Ju
     * @param  {[type]} state [description]
     * @param  {[type]} roles [description]
     */
    setLoginInfo: ({ commit }, data) => {
      commit('setUserInfo', data.userInfo);
      commit('setRoles', data.roles);
      commit('setPasswordPolicy', {
        passwordChangeFlag: data.passwordChangeFlag,
        forcePasswordChangeFlag: data.forcePasswordChangeFlag,
        passwordChangePeried: data.passwordChangePeried,
      });
    },
    checkUserInfo: ({ commit }) => {
      LoginAPI.checkLogin().then((res) => {
        if (res.data.success === true) {
          commit('setUserInfo', res.data.data);
        }
      });
    },
    setRoles: ({ commit }, roles) => {
      commit('setRoles', roles);
    },
  },
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js